import { Button, Col, Input, Row, Space, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import {
  displayFormattedDate,
  formatCurrency,
  isEmpty,
} from "../../../generalFunctions";
import useApi from "../../../hooks/useApi";
import TableComponent from "../../common/table/TableComponent";
import DeleteModal from "../../common/DeleteModal";
import {
  EditOutlined,
  EyeOutlined,
  DeleteOutlined,
  PrinterOutlined,
} from "@ant-design/icons";

function PartyBillTable(props) {
  const columns = [
    {
      title: "Invoice No.",
      dataIndex: "id",
    },
    {
      title: "Invoice Date",
      dataIndex: "invoiceDate",
      render: (text) => displayFormattedDate(text),
    },
    {
      title: "Bill For",
      dataIndex: "billFor",
    },
    // {
    //   title: "Ro For",
    //   dataIndex: "roForId",
    // },
    {
      title: "RO For",
      dataIndex: "roFor",
    },
    {
      title: "Final Bill Amount",
      dataIndex: "finalBillAmount",
      render: (text) => formatCurrency(text),
    },
    {
      title: "Action",
      key: "action",

      render: (text, record) => (
        <Space>
          <Button size="small" onClick={() => editRecord(record)}>
            <EditOutlined />
          </Button>
          <Button size="small" onClick={() => editRecord(record, true)}>
            <EyeOutlined /> / <PrinterOutlined />
          </Button>
          {/* <Button
            size="small"
          // onClick={() => handlePrint(record)}
          >
            Print
          </Button> */}
          <Button size="small" onClick={() => handleDelete(record)}>
            <DeleteOutlined />
          </Button>
        </Space>
      ),
    },
  ];
  const [responseData, getRequest] = useApi(
    "/partyBill",
    null,
    API_METHODS.GET
  );
  const [tableData, setTableData] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [visibleDelete, setVisibleDelete] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    getRequest(
      null,
      API_METHODS.GET,
      `/partyBill?pageNumber=${1}&isClassified=${props.isClassified}`
    );
  }, [props.isClassified]);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    setTableData(data);
    setTotalRecords(data && data.length > 0 ? data[0].count : 0);
  }, [responseData]);

  const editRecord = (record, isViewOnly = false) => {
    if (isViewOnly) {
      navigate("/portal/partyBill/view", {
        state: {
          bill_id: record.id,
          isViewOnly: isViewOnly,
          isClassified: props.isClassified,
        },
      });
    } else {
      navigate("/portal/partyBill/edit", {
        state: {
          bill_id: record.id,
          isViewOnly: isViewOnly,
          isClassified: props.isClassified,
        },
      });
    }
  };

  const onRowSelectChange = (newSelectedRowKeys, records) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(records);
  };

  const rowSelection = {
    selectedRowKeys,
    type: "checkbox",
    onChange: onRowSelectChange,
  };

  const onBillSearch = (id) => {
    if (!isEmpty(id))
      navigate("/portal/partyBill/view", {
        state: {
          bill_id: id,
          isViewOnly: false,
          isClassified: props.isClassified,
        },
      });
  };

  const onPaginationChange = (page) => {
    getRequest(
      null,
      API_METHODS.GET,
      `/partyBill?pageNumber=${page.current}&isClassified=${props.isClassified}`
    );
    setCurrentPage(page.current);
  };

  const handleDelete = (record) => {
    const flag = visibleDelete ? false : true;
    record && setSelectedRecord(record);
    setVisibleDelete(flag);
  };

  return (
    <>
      <Row>
        <Col span={6}>
          <Typography.Title level={5}>Party Bills</Typography.Title>
        </Col>
        <Col span={18}>
          <Space style={{ marginBottom: 10, float: "right" }}>
            <Input.Search
              placeholder="Party Bill Number"
              allowClear
              enterButton="Search"
              onSearch={onBillSearch}
            />
            <Button>
              <Link to="add">Party Bill</Link>
            </Button>
            {/* <Button
              type="primary"
              // onClick={handlePrint}
              disabled={selectedRows.length === 0}
            >
              Print Selected Bills
            </Button> */}
          </Space>
        </Col>
      </Row>
      <TableComponent
        columns={columns}
        tableData={tableData}
        loading={responseData.isLoading}
        // rowSelection={rowSelection}
        onPaginationChange={onPaginationChange}
        total={totalRecords}
        current={currentPage}
      />
      {visibleDelete && (
        <DeleteModal
          visible={visibleDelete}
          close={handleDelete}
          recordType={`PartyBill-${props.isClassified}`}
          record={selectedRecord}
          refresh={() => {
            getRequest(
              null,
              API_METHODS.GET,
              `/partyBill?pageNumber=${1}&isClassified=${props.isClassified}`
            );
          }}
        />
      )}
    </>
  );
}

export default PartyBillTable;
